/* global jQuery COMPONENTS */

COMPONENTS.ComponentContentBlock = (function ($) {
  function ComponentContentBlock () {
    this.$component = $('[data-ecs-component="component-contentblock"]')
    this.$sliderElems = $('[data-ecs-component-control="content-block-slider"]')
    this.$buttonTabs = $('[data-ecs-components-control="tabs"]')
    this.$selectTabs = $('select.ecs_tabs_select')
    this.$tabs = $('[data-ecs-element="tab"]')
    this.$readMoreButtons = $('[data-ecs-control-truncate-content]')
  }

  ComponentContentBlock.prototype.refreshSliders = function (needle) {
    const $activeTab = $(`[data-tab="${needle}"]`)
    const $activeSliders = $('.slick-slider')
    const $slider = $activeTab.find('[data-ecs-component-control="content-block-slider"]')
    $slider.slick('refresh')

    $activeSliders.each(function () {
      const attr = $(this).attr('data-ecs-components-slider-counter');

      // Checking for both false and undefined `attr`
      if (typeof attr !== 'undefined' && attr !== false) {
        const $counter = $slider.find('.slick-dots')
        $counter.addClass('slick-counter')

        $slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
          // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
          const i = (currentSlide ? currentSlide : 0) + 1
          $counter.html(i + '/' + slick.slideCount)
        })
      }
    })
  }

  ComponentContentBlock.prototype.init = function () {
    const utility = new COMPONENTS.Utility()
    const component = this

    component.$sliderElems.each(function () {
      const $slider = $(this)

      $slider.slidesToDisplay = ($slider.data('ecs-components-slide-count') ? $slider.data('ecs-components-slide-count') : 1)
      $slider.slidesToDisplay = $slider.data('ecs-components-slide-autoplay')
      $slider.sliderVars = utility.getSliderVars($slider.slidesToDisplay, null, false, false, $slider.sliderAutoplay)

      $slider.slick($slider.sliderVars)
      utility.bindSliderAriaSelected($slider)
    })

    component.$readMoreButtons.click(function() {
      const $contentElem = component.$component.find('[data-ecs-cb-content-id="' + $(this).data('ecs-control-truncate-content') + '"]')
      $contentElem.toggleClass('ecs_display_content_short')
      $contentElem.toggleClass('ecs_display_content_long')
    })

    if (component.$buttonTabs.length > 0 || (typeof (component.$selectTabs) !== 'undefined' && component.$selectTabs.length > 0)) {
      $('.menu .item').tab({
        onVisible: function () {
          component.refreshSliders($(this).data('tab'))
        }
      })
    }

    if (typeof (component.$selectTabs) !== 'undefined' && component.$selectTabs.length > 0) {
      component.$selectTabs.each(function () {
        $(this).change(function () {
          const needle = $(this).find(':selected').attr('data-tab')
          component.$tabs.tab('change tab', needle)
          component.refreshSliders(needle)
        })
      })
    }
  }

  return ComponentContentBlock
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentContentBlock = new COMPONENTS.ComponentContentBlock()
  COMPONENTS.componentContentBlock.init()
})
